// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__AX97w","form":"styles_form__2YAIx"};